import type { NameFr } from "./drawings.fr";

// Greek text for the drawings, laid over the English data (same pattern as
// drawings.fr.ts). Hints are keyed by the EXACT English string, so a line shared
// across a subject's Easy/Medium/Harder variants translates once.
//
// GENERATED from the translation tables (scratchpad JSON) but checked in and safe
// to hand-edit. The "write the name" finale is NOT in HINTS_EL — it is redrawn
// from the Greek name by localize.ts (nameHintEl builds its spoken hint).
//
// `name` is the nominative (card/grid). `accusative` is the article + accusative
// noun that follows "Πώς να ζωγραφίσεις …" — Greek declines, so the heading needs
// a different form than the card. Flags carry titleGender "f" (σημαία is feminine)
// and are headed "μια <ελληνική σημαία>" by localize.ts, so their accusative field
// is unused.

/** Drawing id → its Greek name (nominative + accusative + gender). */
export const NAMES_EL: Record<string, NameFr> = {
  "bear": { name: "Αρκούδα", accusative: "μια αρκούδα", gender: "f" },
  "bunny": { name: "Κουνελάκι", accusative: "ένα κουνελάκι", gender: "n" },
  "butterfly": { name: "Πεταλούδα", accusative: "μια πεταλούδα", gender: "f" },
  "butterfly-10": { name: "Πεταλούδα", accusative: "μια πεταλούδα", gender: "f" },
  "butterfly-7": { name: "Πεταλούδα", accusative: "μια πεταλούδα", gender: "f" },
  "car": { name: "Αυτοκίνητο", accusative: "ένα αυτοκίνητο", gender: "n" },
  "car-10": { name: "Αυτοκίνητο", accusative: "ένα αυτοκίνητο", gender: "n" },
  "car-7": { name: "Αυτοκίνητο", accusative: "ένα αυτοκίνητο", gender: "n" },
  "cat": { name: "Γάτα", accusative: "μια γάτα", gender: "f" },
  "cat-10": { name: "Γάτα", accusative: "μια γάτα", gender: "f" },
  "cat-7": { name: "Γάτα", accusative: "μια γάτα", gender: "f" },
  "cloud": { name: "Σύννεφο Βροχής", accusative: "ένα σύννεφο βροχής", gender: "n", written: "Συννεφο" },
  "cloud-10": { name: "Σύννεφο Βροχής", accusative: "ένα σύννεφο βροχής", gender: "n", written: "Συννεφο" },
  "cloud-7": { name: "Σύννεφο Βροχής", accusative: "ένα σύννεφο βροχής", gender: "n", written: "Συννεφο" },
  "cow": { name: "Αγελάδα", accusative: "μια αγελάδα", gender: "f" },
  "cubist-face": { name: "Κυβιστικό Πρόσωπο", accusative: "Κυβιστικό Πρόσωπο", gender: "n" },
  "dinosaur": { name: "Δεινόσαυρος", accusative: "έναν δεινόσαυρο", gender: "m" },
  "dinosaur-10": { name: "Δεινόσαυρος", accusative: "έναν δεινόσαυρο", gender: "m" },
  "dinosaur-7": { name: "Δεινόσαυρος", accusative: "έναν δεινόσαυρο", gender: "m" },
  "dinosaur-blue": { name: "Δεινόσαυρος", accusative: "έναν δεινόσαυρο", gender: "m" },
  "dog": { name: "Σκύλος", accusative: "έναν σκύλο", gender: "m" },
  "dog-10": { name: "Σκύλος", accusative: "έναν σκύλο", gender: "m" },
  "dog-7": { name: "Σκύλος", accusative: "έναν σκύλο", gender: "m" },
  "duck": { name: "Πάπια", accusative: "μια πάπια", gender: "f" },
  "elephant": { name: "Ελέφαντας", accusative: "έναν ελέφαντα", gender: "m" },
  "family": { name: "Οικογένεια", accusative: "μια οικογένεια", gender: "f" },
  "family-10": { name: "Οικογένεια", accusative: "μια οικογένεια", gender: "f" },
  "family-7": { name: "Οικογένεια", accusative: "μια οικογένεια", gender: "f" },
  "fish": { name: "Ψάρι", accusative: "ένα ψάρι", gender: "n" },
  "fish-10": { name: "Ψάρι", accusative: "ένα ψάρι", gender: "n" },
  "fish-7": { name: "Ψάρι", accusative: "ένα ψάρι", gender: "n" },
  "flag-algeria": { name: "Αλγερία", accusative: "Αλγερία", gender: "f", titleGender: "f" },
  "flag-argentina": { name: "Αργεντινή", accusative: "Αργεντινή", gender: "f", titleGender: "f" },
  "flag-australia": { name: "Αυστραλία", accusative: "Αυστραλία", gender: "f", titleGender: "f" },
  "flag-austria": { name: "Αυστρία", accusative: "Αυστρία", gender: "f", titleGender: "f" },
  "flag-belgium": { name: "Βέλγιο", accusative: "Βέλγιο", gender: "n", titleGender: "f" },
  "flag-bosnia-and-herzegovina": { name: "Βοσνία και Ερζεγοβίνη", accusative: "Βοσνία και Ερζεγοβίνη", gender: "f", titleGender: "f" },
  "flag-brazil": { name: "Βραζιλία", accusative: "Βραζιλία", gender: "f", titleGender: "f" },
  "flag-canada": { name: "Καναδάς", accusative: "Καναδάς", gender: "m", titleGender: "f" },
  "flag-cape-verde": { name: "Πράσινο Ακρωτήριο", accusative: "Πράσινο Ακρωτήριο", gender: "n", titleGender: "f" },
  "flag-china": { name: "Κίνα", accusative: "Κίνα", gender: "f", titleGender: "f" },
  "flag-colombia": { name: "Κολομβία", accusative: "Κολομβία", gender: "f", titleGender: "f" },
  "flag-croatia": { name: "Κροατία", accusative: "Κροατία", gender: "f", titleGender: "f" },
  "flag-curacao": { name: "Κουρασάο", accusative: "Κουρασάο", gender: "n", titleGender: "f" },
  "flag-czech-republic": { name: "Τσεχία", accusative: "Τσεχία", gender: "f", titleGender: "f" },
  "flag-denmark": { name: "Δανία", accusative: "Δανία", gender: "f", titleGender: "f" },
  "flag-dr-congo": { name: "Κονγκό", accusative: "Κονγκό", gender: "n", titleGender: "f" },
  "flag-ecuador": { name: "Ισημερινός", accusative: "Ισημερινός", gender: "m", titleGender: "f" },
  "flag-egypt": { name: "Αίγυπτος", accusative: "Αίγυπτος", gender: "f", titleGender: "f" },
  "flag-england": { name: "Αγγλία", accusative: "Αγγλία", gender: "f", titleGender: "f" },
  "flag-finland": { name: "Φινλανδία", accusative: "Φινλανδία", gender: "f", titleGender: "f" },
  "flag-france": { name: "Γαλλία", accusative: "Γαλλία", gender: "f", titleGender: "f" },
  "flag-germany": { name: "Γερμανία", accusative: "Γερμανία", gender: "f", titleGender: "f" },
  "flag-ghana": { name: "Γκάνα", accusative: "Γκάνα", gender: "f", titleGender: "f" },
  "flag-greece": { name: "Ελλάδα", accusative: "Ελλάδα", gender: "f", titleGender: "f" },
  "flag-haiti": { name: "Αϊτή", accusative: "Αϊτή", gender: "f", titleGender: "f" },
  "flag-india": { name: "Ινδία", accusative: "Ινδία", gender: "f", titleGender: "f" },
  "flag-iran": { name: "Ιράν", accusative: "Ιράν", gender: "n", titleGender: "f" },
  "flag-iraq": { name: "Ιράκ", accusative: "Ιράκ", gender: "n", titleGender: "f" },
  "flag-ireland": { name: "Ιρλανδία", accusative: "Ιρλανδία", gender: "f", titleGender: "f" },
  "flag-italy": { name: "Ιταλία", accusative: "Ιταλία", gender: "f", titleGender: "f" },
  "flag-ivory-coast": { name: "Ακτή Ελεφαντοστού", accusative: "Ακτή Ελεφαντοστού", gender: "f", titleGender: "f" },
  "flag-japan": { name: "Ιαπωνία", accusative: "Ιαπωνία", gender: "f", titleGender: "f" },
  "flag-jordan": { name: "Ιορδανία", accusative: "Ιορδανία", gender: "f", titleGender: "f" },
  "flag-mexico": { name: "Μεξικό", accusative: "Μεξικό", gender: "n", titleGender: "f" },
  "flag-morocco": { name: "Μαρόκο", accusative: "Μαρόκο", gender: "n", titleGender: "f" },
  "flag-netherlands": { name: "Ολλανδία", accusative: "Ολλανδία", gender: "f", titleGender: "f" },
  "flag-new-zealand": { name: "Νέα Ζηλανδία", accusative: "Νέα Ζηλανδία", gender: "f", titleGender: "f" },
  "flag-norway": { name: "Νορβηγία", accusative: "Νορβηγία", gender: "f", titleGender: "f" },
  "flag-panama": { name: "Παναμάς", accusative: "Παναμάς", gender: "m", titleGender: "f" },
  "flag-paraguay": { name: "Παραγουάη", accusative: "Παραγουάη", gender: "f", titleGender: "f" },
  "flag-portugal": { name: "Πορτογαλία", accusative: "Πορτογαλία", gender: "f", titleGender: "f" },
  "flag-qatar": { name: "Κατάρ", accusative: "Κατάρ", gender: "n", titleGender: "f" },
  "flag-saudi-arabia": { name: "Σαουδική Αραβία", accusative: "Σαουδική Αραβία", gender: "f", titleGender: "f" },
  "flag-scotland": { name: "Σκωτία", accusative: "Σκωτία", gender: "f", titleGender: "f" },
  "flag-senegal": { name: "Σενεγάλη", accusative: "Σενεγάλη", gender: "f", titleGender: "f" },
  "flag-singapore": { name: "Σιγκαπούρη", accusative: "Σιγκαπούρη", gender: "f", titleGender: "f" },
  "flag-south-africa": { name: "Νότια Αφρική", accusative: "Νότια Αφρική", gender: "f", titleGender: "f" },
  "flag-south-korea": { name: "Νότια Κορέα", accusative: "Νότια Κορέα", gender: "f", titleGender: "f" },
  "flag-spain": { name: "Ισπανία", accusative: "Ισπανία", gender: "f", titleGender: "f" },
  "flag-sweden": { name: "Σουηδία", accusative: "Σουηδία", gender: "f", titleGender: "f" },
  "flag-switzerland": { name: "Ελβετία", accusative: "Ελβετία", gender: "f", titleGender: "f" },
  "flag-tunisia": { name: "Τυνησία", accusative: "Τυνησία", gender: "f", titleGender: "f" },
  "flag-turkey": { name: "Τουρκία", accusative: "Τουρκία", gender: "f", titleGender: "f" },
  "flag-united-arab-emirates": { name: "Ηνωμένα Αραβικά Εμιράτα", accusative: "Ηνωμένα Αραβικά Εμιράτα", gender: "n", titleGender: "f" },
  "flag-united-kingdom": { name: "Ηνωμένο Βασίλειο", accusative: "Ηνωμένο Βασίλειο", gender: "n", titleGender: "f" },
  "flag-united-states": { name: "Ηνωμένες Πολιτείες", accusative: "Ηνωμένες Πολιτείες", gender: "f", titleGender: "f" },
  "flag-uruguay": { name: "Ουρουγουάη", accusative: "Ουρουγουάη", gender: "f", titleGender: "f" },
  "flag-uzbekistan": { name: "Ουζμπεκιστάν", accusative: "Ουζμπεκιστάν", gender: "n", titleGender: "f" },
  "flower": { name: "Λουλούδι", accusative: "ένα λουλούδι", gender: "n" },
  "flower-10": { name: "Λουλούδι", accusative: "ένα λουλούδι", gender: "n" },
  "flower-7": { name: "Λουλούδι", accusative: "ένα λουλούδι", gender: "n" },
  "fox": { name: "Αλεπού", accusative: "μια αλεπού", gender: "f" },
  "frog": { name: "Βάτραχος", accusative: "έναν βάτραχο", gender: "m" },
  "great-wave": { name: "Το Μεγάλο Κύμα", accusative: "Το Μεγάλο Κύμα", gender: "n" },
  "hamster": { name: "Χάμστερ", accusative: "ένα χάμστερ", gender: "n" },
  "heart": { name: "Καρδιά", accusative: "μια καρδιά", gender: "f" },
  "heart-10": { name: "Καρδιά", accusative: "μια καρδιά", gender: "f" },
  "heart-7": { name: "Καρδιά", accusative: "μια καρδιά", gender: "f" },
  "hedgehog": { name: "Σκαντζόχοιρος", accusative: "έναν σκαντζόχοιρο", gender: "m" },
  "hedgehog-10": { name: "Σκαντζόχοιρος", accusative: "έναν σκαντζόχοιρο", gender: "m" },
  "hedgehog-7": { name: "Σκαντζόχοιρος", accusative: "έναν σκαντζόχοιρο", gender: "m" },
  "heromask": { name: "Σούπερ-Στόρμι", accusative: "τον Σούπερ-Στόρμι", gender: "m" },
  "heromask-10": { name: "Σούπερ-Στόρμι", accusative: "τον Σούπερ-Στόρμι", gender: "m" },
  "heromask-7": { name: "Σούπερ-Στόρμι", accusative: "τον Σούπερ-Στόρμι", gender: "m" },
  "horse": { name: "Άλογο", accusative: "ένα άλογο", gender: "n" },
  "horse-10": { name: "Άλογο", accusative: "ένα άλογο", gender: "n" },
  "horse-7": { name: "Άλογο", accusative: "ένα άλογο", gender: "n" },
  "house": { name: "Σπίτι", accusative: "ένα σπίτι", gender: "n" },
  "house-10": { name: "Σπίτι", accusative: "ένα σπίτι", gender: "n" },
  "house-7": { name: "Σπίτι", accusative: "ένα σπίτι", gender: "n" },
  "ice-cream": { name: "Παγωτό", accusative: "ένα παγωτό", gender: "n" },
  "jersey": { name: "Φανέλα", accusative: "μια φανέλα", gender: "f" },
  "lion": { name: "Λιοντάρι", accusative: "ένα λιοντάρι", gender: "n" },
  "mouse": { name: "Ποντίκι", accusative: "ένα ποντίκι", gender: "n" },
  "penguin": { name: "Πιγκουίνος", accusative: "έναν πιγκουίνο", gender: "m" },
  "picasso-portrait": { name: "Πορτρέτο σε στιλ Πικάσο", accusative: "Πορτρέτο σε στιλ Πικάσο", gender: "n" },
  "pig": { name: "Γουρούνι", accusative: "ένα γουρούνι", gender: "n" },
  "popstar": { name: "Ποπ Σταρ", accusative: "έναν ποπ σταρ", gender: "m" },
  "popstar-10": { name: "Ποπ Σταρ", accusative: "έναν ποπ σταρ", gender: "m" },
  "popstar-7": { name: "Ποπ Σταρ", accusative: "έναν ποπ σταρ", gender: "m" },
  "princess": { name: "Πριγκίπισσα", accusative: "μια πριγκίπισσα", gender: "f" },
  "princess-10": { name: "Πριγκίπισσα", accusative: "μια πριγκίπισσα", gender: "f" },
  "princess-7": { name: "Πριγκίπισσα", accusative: "μια πριγκίπισσα", gender: "f" },
  "rainbow": { name: "Ουράνιο Τόξο", accusative: "ένα ουράνιο τόξο", gender: "n" },
  "rainbow-10": { name: "Ουράνιο Τόξο", accusative: "ένα ουράνιο τόξο", gender: "n" },
  "rainbow-7": { name: "Ουράνιο Τόξο", accusative: "ένα ουράνιο τόξο", gender: "n" },
  "shape-circle": { name: "Κύκλος", accusative: "έναν κύκλο", gender: "m" },
  "shape-crescent": { name: "Μισοφέγγαρο", accusative: "ένα μισοφέγγαρο", gender: "n" },
  "shape-diamond": { name: "Ρόμβος", accusative: "έναν ρόμβο", gender: "m" },
  "shape-heart": { name: "Καρδιά", accusative: "μια καρδιά", gender: "f" },
  "shape-hexagon": { name: "Εξάγωνο", accusative: "ένα εξάγωνο", gender: "n" },
  "shape-octagon": { name: "Οκτάγωνο", accusative: "ένα οκτάγωνο", gender: "n" },
  "shape-oval": { name: "Οβάλ", accusative: "ένα οβάλ", gender: "n" },
  "shape-parallelogram": { name: "Παραλληλόγραμμο", accusative: "ένα παραλληλόγραμμο", gender: "n" },
  "shape-pentagon": { name: "Πεντάγωνο", accusative: "ένα πεντάγωνο", gender: "n" },
  "shape-rectangle": { name: "Ορθογώνιο", accusative: "ένα ορθογώνιο", gender: "n" },
  "shape-square": { name: "Τετράγωνο", accusative: "ένα τετράγωνο", gender: "n" },
  "shape-star": { name: "Αστέρι", accusative: "ένα αστέρι", gender: "n" },
  "shape-trapezium": { name: "Τραπέζιο", accusative: "ένα τραπέζιο", gender: "n" },
  "shape-triangle": { name: "Τρίγωνο", accusative: "ένα τρίγωνο", gender: "n" },
  "snail": { name: "Σαλιγκάρι", accusative: "ένα σαλιγκάρι", gender: "n" },
  "star": { name: "Αστέρι", accusative: "ένα αστέρι", gender: "n" },
  "star-10": { name: "Αστέρι", accusative: "ένα αστέρι", gender: "n" },
  "star-7": { name: "Αστέρι", accusative: "ένα αστέρι", gender: "n" },
  "starry-night": { name: "Έναστρη Νύχτα", accusative: "Έναστρη Νύχτα", gender: "f" },
  "sun": { name: "Ήλιος", accusative: "έναν ήλιο", gender: "m" },
  "sun-10": { name: "Ήλιος", accusative: "έναν ήλιο", gender: "m" },
  "sun-7": { name: "Ήλιος", accusative: "έναν ήλιο", gender: "m" },
  "tree": { name: "Δέντρο", accusative: "ένα δέντρο", gender: "n" },
  "tree-10": { name: "Δέντρο", accusative: "ένα δέντρο", gender: "n" },
  "tree-7": { name: "Δέντρο", accusative: "ένα δέντρο", gender: "n" },
  "unicorn-10": { name: "Μονόκερος", accusative: "έναν μονόκερο", gender: "m" },
  "whale": { name: "Φάλαινα", accusative: "μια φάλαινα", gender: "f" },
};

/** English flag title → Greek ("<feminine demonym> σημαία", lower-case). */
export const TITLES_EL: Record<string, string> = {
  "Algerian flag": "αλγερινή σημαία",
  "American flag": "αμερικανική σημαία",
  "Argentine flag": "αργεντίνικη σημαία",
  "Australian flag": "αυστραλιανή σημαία",
  "Austrian flag": "αυστριακή σημαία",
  "Belgian flag": "βελγική σημαία",
  "Bosnian flag": "βοσνιακή σημαία",
  "Brazilian flag": "βραζιλιάνικη σημαία",
  "British flag": "βρετανική σημαία",
  "Canadian flag": "καναδική σημαία",
  "Cape Verdean flag": "σημαία του Πράσινου Ακρωτηρίου",
  "Chinese flag": "κινεζική σημαία",
  "Colombian flag": "κολομβιανή σημαία",
  "Congolese flag": "κονγκολέζικη σημαία",
  "Croatian flag": "κροατική σημαία",
  "Curaçao flag": "σημαία του Κουρασάο",
  "Czech flag": "τσεχική σημαία",
  "Danish flag": "δανική σημαία",
  "Dutch flag": "ολλανδική σημαία",
  "Ecuadorian flag": "σημαία του Ισημερινού",
  "Egyptian flag": "αιγυπτιακή σημαία",
  "Emirati flag": "σημαία των Ηνωμένων Αραβικών Εμιράτων",
  "English flag": "αγγλική σημαία",
  "Finnish flag": "φινλανδική σημαία",
  "French flag": "γαλλική σημαία",
  "German flag": "γερμανική σημαία",
  "Ghanaian flag": "γκανέζικη σημαία",
  "Greek flag": "ελληνική σημαία",
  "Haitian flag": "αϊτινή σημαία",
  "Indian flag": "ινδική σημαία",
  "Iranian flag": "ιρανική σημαία",
  "Iraqi flag": "ιρακινή σημαία",
  "Irish flag": "ιρλανδική σημαία",
  "Italian flag": "ιταλική σημαία",
  "Ivorian flag": "σημαία της Ακτής Ελεφαντοστού",
  "Japanese flag": "ιαπωνική σημαία",
  "Jordanian flag": "ιορδανική σημαία",
  "Mexican flag": "μεξικανική σημαία",
  "Moroccan flag": "μαροκινή σημαία",
  "New Zealand flag": "νεοζηλανδική σημαία",
  "Norwegian flag": "νορβηγική σημαία",
  "Panamanian flag": "παναμαϊκή σημαία",
  "Paraguayan flag": "παραγουανή σημαία",
  "Portuguese flag": "πορτογαλική σημαία",
  "Qatari flag": "καταριανή σημαία",
  "Saudi flag": "σαουδαραβική σημαία",
  "Scottish flag": "σκωτσέζικη σημαία",
  "Senegalese flag": "σενεγαλέζικη σημαία",
  "Singaporean flag": "σιγκαπουριανή σημαία",
  "South African flag": "νοτιοαφρικανική σημαία",
  "South Korean flag": "νοτιοκορεατική σημαία",
  "Spanish flag": "ισπανική σημαία",
  "Swedish flag": "σουηδική σημαία",
  "Swiss flag": "ελβετική σημαία",
  "Tunisian flag": "τυνησιακή σημαία",
  "Turkish flag": "τουρκική σημαία",
  "Uruguayan flag": "ουρουγουανή σημαία",
  "Uzbek flag": "ουζμπεκική σημαία",
};

/** English fact → Greek. */
export const FACTS_EL: Record<string, string> = {
  "A circle is perfectly round — it has no corners at all! The sun and the moon are circles. ☀️": "Ο κύκλος είναι τέλεια στρογγυλός — δεν έχει καθόλου γωνίες! Ο ήλιος και το φεγγάρι είναι κύκλοι. ☀️",
  "A crescent is the curvy shape the moon makes at night! 🌙": "Η ημισέληνος είναι το καμπυλωτό σχήμα που κάνει το φεγγάρι τη νύχτα! 🌙",
  "A diamond is a square balancing on one of its corners! 💎": "Ο ρόμβος είναι ένα τετράγωνο που ισορροπεί σε μία γωνία του! 💎",
  "A heart is the shape we use to show love! 💕": "Η καρδιά είναι το σχήμα που δείχνει την αγάπη! 💕",
  "A hexagon has 6 sides — bees build their honeycomb out of hexagons! 🐝": "Το εξάγωνο έχει 6 πλευρές — οι μέλισσες φτιάχνουν την κηρήθρα τους από εξάγωνα! 🐝",
  "A parallelogram is like a rectangle that leaned over to one side!": "Το παραλληλόγραμμο είναι σαν ορθογώνιο που έγειρε στο πλάι!",
  "A pentagon has 5 straight sides — a little house is shaped a bit like one! 🏠": "Το πεντάγωνο έχει 5 ίσιες πλευρές — ένα σπιτάκι μοιάζει λιγάκι μ' αυτό! 🏠",
  "A rectangle has 4 corners, with 2 long sides and 2 short sides — like a door! 🚪": "Το ορθογώνιο έχει 4 γωνίες, με 2 μακριές πλευρές και 2 κοντές — σαν πόρτα! 🚪",
  "A square has 4 sides that are all exactly the same length!": "Το τετράγωνο έχει 4 πλευρές που είναι όλες ακριβώς ίδιες!",
  "A star has 5 points that twinkle in the night sky! ✨": "Το αστέρι έχει 5 μύτες που λαμπυρίζουν στον νυχτερινό ουρανό! ✨",
  "A trapezium has 4 sides, with a flat top and a flat bottom that aren't the same width!": "Το τραπέζιο έχει 4 πλευρές, με ίσια κορυφή κι ίσια βάση που δεν έχουν το ίδιο πλάτος!",
  "A triangle has 3 sides and 3 pointy corners!": "Το τρίγωνο έχει 3 πλευρές και 3 μυτερές γωνίες!",
  "Algeria's flag has a red moon and star.": "Η σημαία της Αλγερίας έχει ένα κόκκινο φεγγάρι κι ένα αστέρι.",
  "An octagon has 8 sides — a red STOP sign is an octagon! 🛑": "Το οκτάγωνο έχει 8 πλευρές — η κόκκινη πινακίδα STOP είναι οκτάγωνο! 🛑",
  "An oval is like a circle that got gently squished — an egg is an oval! 🥚": "Το οβάλ είναι σαν κύκλος που ζουλήχτηκε λιγάκι — το αυγό είναι οβάλ! 🥚",
  "Argentina's flag has a smiling golden sun.": "Η σημαία της Αργεντινής έχει έναν χαμογελαστό χρυσό ήλιο.",
  "Australia's flag shows the Southern Cross stars.": "Η σημαία της Αυστραλίας δείχνει τα αστέρια του Σταυρού του Νότου.",
  "Austria's flag is red, white, red.": "Η σημαία της Αυστρίας είναι κόκκινη, λευκή, κόκκινη.",
  "Belgium's flag is black, yellow and red.": "Η σημαία του Βελγίου είναι μαύρη, κίτρινη και κόκκινη.",
  "Bosnia's flag has a yellow triangle and white stars.": "Η σημαία της Βοσνίας έχει ένα κίτρινο τρίγωνο και λευκά αστέρια.",
  "Brazil's flag has a starry blue globe.": "Η σημαία της Βραζιλίας έχει μια γαλάζια υδρόγειο με αστέρια.",
  "Canada's flag shows a red maple leaf.": "Η σημαία του Καναδά δείχνει ένα κόκκινο φύλλο σφενδάμου.",
  "Cape Verde's flag has ten yellow stars in a circle.": "Η σημαία του Πράσινου Ακρωτηρίου έχει δέκα κίτρινα αστέρια σε κύκλο.",
  "China's flag has one big star and four small ones.": "Η σημαία της Κίνας έχει ένα μεγάλο αστέρι και τέσσερα μικρά.",
  "Colombia's flag is yellow, blue and red.": "Η σημαία της Κολομβίας είναι κίτρινη, μπλε και κόκκινη.",
  "Croatia's flag has a red-and-white checkerboard.": "Η σημαία της Κροατίας έχει ένα κόκκινο και άσπρο σκακιστικό σχέδιο.",
  "Curaçao's flag has two white stars.": "Η σημαία του Κουρασάο έχει δύο λευκά αστέρια.",
  "DR Congo's flag has a yellow star and a red stripe.": "Η σημαία του Κονγκό έχει ένα κίτρινο αστέρι και μια κόκκινη λωρίδα.",
  "Denmark's flag is the oldest in the world!": "Η σημαία της Δανίας είναι η πιο παλιά στον κόσμο!",
  "Ecuador's flag has a condor on a shield.": "Η σημαία του Ισημερινού έχει έναν κόνδορα πάνω σε μια ασπίδα.",
  "Egypt's flag has a golden eagle.": "Η σημαία της Αιγύπτου έχει έναν χρυσό αετό.",
  "England's flag is a red cross.": "Η σημαία της Αγγλίας είναι ένας κόκκινος σταυρός.",
  "Finland's flag has a blue cross.": "Η σημαία της Φινλανδίας έχει έναν μπλε σταυρό.",
  "France's flag is called the Tricolore.": "Η σημαία της Γαλλίας λέγεται Τρικολόρ, η τρίχρωμη.",
  "Germany's flag is black, red and gold.": "Η σημαία της Γερμανίας είναι μαύρη, κόκκινη και χρυσή.",
  "Ghana's flag has a black star.": "Η σημαία της Γκάνας έχει ένα μαύρο αστέρι.",
  "Greece's flag has nine blue and white stripes.": "Η σημαία της Ελλάδας έχει εννέα γαλάζιες και άσπρες ρίγες.",
  "Haiti's flag has a palm tree in the middle.": "Η σημαία της Αϊτής έχει έναν φοίνικα στη μέση.",
  "Hokusai made this in Japan almost 200 years ago — it's printed from carved wood!": "Ο Χοκουσάι το έφτιαξε στην Ιαπωνία σχεδόν 200 χρόνια πριν — είναι τυπωμένο από σκαλισμένο ξύλο!",
  "In real life, Switzerland's flag is a perfect square!": "Στην πραγματικότητα, η σημαία της Ελβετίας είναι ένα τέλειο τετράγωνο!",
  "India's flag has a blue wheel in the middle.": "Η σημαία της Ινδίας έχει έναν μπλε τροχό στη μέση.",
  "Iran's flag has a red emblem in the middle.": "Η σημαία του Ιράν έχει ένα κόκκινο έμβλημα στη μέση.",
  "Iraq's flag has green writing in the middle.": "Η σημαία του Ιράκ έχει πράσινα γράμματα στη μέση.",
  "Ireland's flag is green, white and orange.": "Η σημαία της Ιρλανδίας είναι πράσινη, λευκή και πορτοκαλί.",
  "Italy's flag is green, white and red.": "Η σημαία της Ιταλίας είναι πράσινη, λευκή και κόκκινη.",
  "Ivory Coast's flag is orange, white and green.": "Η σημαία της Ακτής Ελεφαντοστού είναι πορτοκαλί, λευκή και πράσινη.",
  "Japan's flag shows the rising sun.": "Η σημαία της Ιαπωνίας δείχνει τον ήλιο που ανατέλλει.",
  "Jordan's flag has a white star with seven points.": "Η σημαία της Ιορδανίας έχει ένα λευκό αστέρι με επτά ακτίνες.",
  "Mexico's flag has an eagle on a cactus.": "Η σημαία του Μεξικού έχει έναν αετό πάνω σε έναν κάκτο.",
  "Morocco's flag has a green star.": "Η σημαία του Μαρόκου έχει ένα πράσινο αστέρι.",
  "New Zealand's flag has four red stars.": "Η σημαία της Νέας Ζηλανδίας έχει τέσσερα κόκκινα αστέρια.",
  "Norway's flag has a cross inside a cross.": "Η σημαία της Νορβηγίας έχει έναν σταυρό μέσα σε έναν σταυρό.",
  "Panama's flag has a blue star and a red star.": "Η σημαία του Παναμά έχει ένα μπλε αστέρι κι ένα κόκκινο αστέρι.",
  "Paraguay's flag has a star in the middle.": "Η σημαία της Παραγουάης έχει ένα αστέρι στη μέση.",
  "Picasso drew faces from the front and the side at the same time — that's Cubism!": "Ο Πικάσο ζωγράφιζε πρόσωπα από μπροστά και από το πλάι ταυτόχρονα — αυτό είναι ο Κυβισμός!",
  "Picasso often showed a face from the front and the side at the same time — two views in one!": "Ο Πικάσο συχνά έδειχνε ένα πρόσωπο από μπροστά και από το πλάι ταυτόχρονα — δύο όψεις σε μία!",
  "Portugal's flag has a golden sphere and a shield.": "Η σημαία της Πορτογαλίας έχει μια χρυσή σφαίρα και μια ασπίδα.",
  "Qatar's flag has nine white points.": "Η σημαία του Κατάρ έχει εννέα λευκές αιχμές.",
  "Saudi Arabia's flag has a sword.": "Η σημαία της Σαουδικής Αραβίας έχει ένα σπαθί.",
  "Scotland's flag is a white X on blue.": "Η σημαία της Σκωτίας είναι ένα λευκό Χ σε μπλε φόντο.",
  "Senegal's flag has a green star.": "Η σημαία της Σενεγάλης έχει ένα πράσινο αστέρι.",
  "Singapore's flag has a moon and five stars.": "Η σημαία της Σιγκαπούρης έχει ένα φεγγάρι και πέντε αστέρια.",
  "South Africa's flag has six colours in a Y shape.": "Η σημαία της Νότιας Αφρικής έχει έξι χρώματα σε σχήμα Υ.",
  "South Korea's flag has a red-and-blue circle.": "Η σημαία της Νότιας Κορέας έχει έναν κόκκινο και μπλε κύκλο.",
  "Spain's flag has a crown and a shield.": "Η σημαία της Ισπανίας έχει μια κορώνα και μια ασπίδα.",
  "Sweden's flag has a yellow cross.": "Η σημαία της Σουηδίας έχει έναν κίτρινο σταυρό.",
  "The Czech flag has a blue triangle.": "Η τσεχική σημαία έχει ένα μπλε τρίγωνο.",
  "The Netherlands flag is red, white and blue.": "Η σημαία της Ολλανδίας είναι κόκκινη, λευκή και μπλε.",
  "The UAE flag has four colours.": "Η σημαία των Ηνωμένων Αραβικών Εμιράτων έχει τέσσερα χρώματα.",
  "The USA flag has 13 stripes and 50 stars!": "Η σημαία των Η.Π.Α. έχει 13 ρίγες και 50 αστέρια!",
  "The Union Jack joins three crosses together.": "Η βρετανική σημαία ενώνει τρεις σταυρούς μαζί.",
  "Tunisia's flag has a red moon and star in a white circle.": "Η σημαία της Τυνησίας έχει ένα κόκκινο φεγγάρι κι ένα αστέρι μέσα σε έναν λευκό κύκλο.",
  "Turkey's flag has a white moon and star.": "Η σημαία της Τουρκίας έχει ένα λευκό φεγγάρι κι ένα αστέρι.",
  "Uruguay's flag has a golden sun and nine stripes.": "Η σημαία της Ουρουγουάης έχει έναν χρυσό ήλιο και εννέα ρίγες.",
  "Uzbekistan's flag has a moon and stars.": "Η σημαία του Ουζμπεκιστάν έχει ένα φεγγάρι και αστέρια.",
  "Vincent van Gogh painted Starry Night from his window — with big swirly brushstrokes!": "Ο Βίνσεντ βαν Γκογκ ζωγράφισε την Έναστρη Νύχτα από το παράθυρό του — με μεγάλες στροβιλιστές πινελιές!",
};

/** English step hint → Greek (keyed by the exact English string). */
export const HINTS_EL: Record<string, string> = {
  "Add 10 little stars in a circle ⭐": "Πρόσθεσε 10 μικρά αστέρια σε κύκλο ⭐",
  "Add 13 stripes across": "Πρόσθεσε 13 οριζόντιες ρίγες",
  "Add 3 stripes across": "Πρόσθεσε 3 οριζόντιες ρίγες",
  "Add 3 stripes across the rest": "Πρόσθεσε 3 οριζόντιες ρίγες στο υπόλοιπο",
  "Add 3 stripes up and down": "Πρόσθεσε 3 κάθετες ρίγες",
  "Add 50 little stars ⭐": "Πρόσθεσε 50 μικρά αστέρια ⭐",
  "Add 9 stripes across": "Πρόσθεσε 9 οριζόντιες ρίγες",
  "Add a band across the bottom half": "Πρόσθεσε μια λωρίδα στο κάτω μισό",
  "Add a big cloud of leaves 🌳": "Πρόσθεσε ένα μεγάλο σύννεφο από φύλλα 🌳",
  "Add a big flowing cape!": "Πρόσθεσε μια μεγάλη κάπα που ανεμίζει!",
  "Add a big friendly smile 😄": "Πρόσθεσε ένα μεγάλο φιλικό χαμόγελο 😄",
  "Add a big muzzle and a smile 🐽": "Πρόσθεσε μια μεγάλη μουσούδα και ένα χαμόγελο 🐽",
  "Add a big singing smile 🎶": "Πρόσθεσε ένα μεγάλο τραγουδιστό χαμόγελο 🎶",
  "Add a big smile 😄": "Πρόσθεσε ένα μεγάλο χαμόγελο 😄",
  "Add a big snout 🐽": "Πρόσθεσε μια μεγάλη μουσούδα 🐽",
  "Add a big zig-zag lightning bolt! ⚡": "Πρόσθεσε μια μεγάλη αστραπή ζιγκ-ζαγκ! ⚡",
  "Add a box in the corner": "Πρόσθεσε ένα πλαίσιο στη γωνία",
  "Add a box in the corner for the stars": "Πρόσθεσε ένα πλαίσιο στη γωνία για τα αστέρια",
  "Add a box in the corner for the sun": "Πρόσθεσε ένα πλαίσιο στη γωνία για τον ήλιο",
  "Add a brave smile": "Πρόσθεσε ένα γενναίο χαμόγελο",
  "Add a bright sun! ☀️": "Πρόσθεσε έναν λαμπερό ήλιο! ☀️",
  "Add a buzzy bee 🐝": "Πρόσθεσε μια βουίζουσα μέλισσα 🐝",
  "Add a collar with a name tag": "Πρόσθεσε ένα κολάρο με ταμπελάκι ονόματος",
  "Add a colourful umbrella ☂️": "Πρόσθεσε μια πολύχρωμη ομπρέλα ☂️",
  "Add a crescent moon 🌙": "Πρόσθεσε ένα μισοφέγγαρο 🌙",
  "Add a crooked smile 🙂": "Πρόσθεσε ένα στραβό χαμόγελο 🙂",
  "Add a cross in the box ➕": "Πρόσθεσε έναν σταυρό στο πλαίσιο ➕",
  "Add a cross — a tall line and a wide line ➕": "Πρόσθεσε έναν σταυρό — μια ψηλή γραμμή και μια φαρδιά γραμμή ➕",
  "Add a curly tail!": "Πρόσθεσε μια σγουρή ουρά!",
  "Add a curvy band 🎀": "Πρόσθεσε μια καμπυλωτή κορδέλα 🎀",
  "Add a cute nose 👃": "Πρόσθεσε μια χαριτωμένη μύτη 👃",
  "Add a door, handle and headlight": "Πρόσθεσε μια πόρτα, ένα χερούλι και ένα φανάρι",
  "Add a fat white cross in the middle ➕": "Πρόσθεσε έναν χοντρό άσπρο σταυρό στη μέση ➕",
  "Add a fin on top and bottom": "Πρόσθεσε ένα πτερύγιο πάνω και κάτω",
  "Add a five-point star ⭐": "Πρόσθεσε ένα πεντάκτινο αστέρι ⭐",
  "Add a flowing cape!": "Πρόσθεσε μια κάπα που ανεμίζει!",
  "Add a fluffy cloud at each end ☁️": "Πρόσθεσε ένα αφράτο σύννεφο σε κάθε άκρη ☁️",
  "Add a fluffy cloud on the left ☁️": "Πρόσθεσε ένα αφράτο σύννεφο αριστερά ☁️",
  "Add a fluffy cloud ☁️": "Πρόσθεσε ένα αφράτο σύννεφο ☁️",
  "Add a glowing moon and twinkly stars 🌙": "Πρόσθεσε ένα λαμπερό φεγγάρι και αστεράκια που τρεμοπαίζουν 🌙",
  "Add a happy eye 👀": "Πρόσθεσε ένα χαρούμενο μάτι 👀",
  "Add a hero belt": "Πρόσθεσε μια ζώνη ήρωα",
  "Add a line across the middle": "Πρόσθεσε μια γραμμή στη μέση",
  "Add a line down": "Πρόσθεσε μια κάθετη γραμμή",
  "Add a line down for the red bar": "Πρόσθεσε μια κάθετη γραμμή για την κόκκινη μπάρα",
  "Add a line down the middle": "Πρόσθεσε μια γραμμή στη μέση",
  "Add a line of little stars ⭐": "Πρόσθεσε μια σειρά από μικρά αστέρια ⭐",
  "Add a little arm": "Πρόσθεσε ένα μικρό χεράκι",
  "Add a little bird 🐦": "Πρόσθεσε ένα μικρό πουλί 🐦",
  "Add a little cluster of stars ⭐": "Πρόσθεσε ένα μικρό σμήνος αστεριών ⭐",
  "Add a little feather tuft on top 🪶": "Πρόσθεσε μια μικρή τούφα από φτερά στην κορυφή 🪶",
  "Add a little fence and flowers 🌷": "Πρόσθεσε έναν μικρό φράχτη και λουλούδια 🌷",
  "Add a little nose 👃": "Πρόσθεσε μια μικρή μύτη 👃",
  "Add a little orange beak 🔶": "Πρόσθεσε ένα μικρό πορτοκαλί ράμφος 🔶",
  "Add a little tongue!": "Πρόσθεσε μια μικρή γλώσσα!",
  "Add a little triangle nose 👃": "Πρόσθεσε μια μικρή τριγωνική μύτη 👃",
  "Add a long horse head from the side": "Πρόσθεσε ένα μακρύ κεφάλι αλόγου από το πλάι",
  "Add a long neck and a big head": "Πρόσθεσε έναν μακρύ λαιμό και ένα μεγάλο κεφάλι",
  "Add a long swishy tail": "Πρόσθεσε μια μακριά κουνιστή ουρά",
  "Add a long trunk 🐘": "Πρόσθεσε μια μακριά προβοσκίδα 🐘",
  "Add a magic wand! ✨": "Πρόσθεσε ένα μαγικό ραβδί! ✨",
  "Add a microphone to sing into! 🎤": "Πρόσθεσε ένα μικρόφωνο για να τραγουδάει! 🎤",
  "Add a microphone with a cord 🎤": "Πρόσθεσε ένα μικρόφωνο με καλώδιο 🎤",
  "Add a nose and a smile 👃": "Πρόσθεσε μια μύτη και ένα χαμόγελο 👃",
  "Add a nose and a smile 😄": "Πρόσθεσε μια μύτη και ένα χαμόγελο 😄",
  "Add a nose seen from the side 👃": "Πρόσθεσε μια μύτη ιδωμένη από το πλάι 👃",
  "Add a pointy ear 👂": "Πρόσθεσε ένα μυτερό αυτί 👂",
  "Add a rosy cheek and a smile 😊": "Πρόσθεσε ένα ροδαλό μάγουλο και ένα χαμόγελο 😊",
  "Add a round face on top 🟡": "Πρόσθεσε ένα στρογγυλό πρόσωπο από πάνω 🟡",
  "Add a second row of spikes": "Πρόσθεσε μια δεύτερη σειρά αγκάθια",
  "Add a second row of spikes!": "Πρόσθεσε μια δεύτερη σειρά αγκάθια!",
  "Add a shiny highlight ✨": "Πρόσθεσε μια γυαλιστερή λάμψη ✨",
  "Add a shiny star on the shirt ⭐": "Πρόσθεσε ένα γυαλιστερό αστέρι στη μπλούζα ⭐",
  "Add a side mirror and a puff of exhaust 💨": "Πρόσθεσε έναν πλαϊνό καθρέφτη και έναν καπνό από την εξάτμιση 💨",
  "Add a smile and rosy cheeks 😊": "Πρόσθεσε ένα χαμόγελο και ροδαλά μάγουλα 😊",
  "Add a smile and whiskers 〰️": "Πρόσθεσε ένα χαμόγελο και μουστάκια 〰️",
  "Add a smile 😄": "Πρόσθεσε ένα χαμόγελο 😄",
  "Add a smiley mouth and a forelock 😄": "Πρόσθεσε ένα χαμογελαστό στόμα και μια αφέλεια 😄",
  "Add a soft snout 🤎": "Πρόσθεσε μια απαλή μουσούδα 🤎",
  "Add a soft white tummy 🤍": "Πρόσθεσε μια απαλή άσπρη κοιλίτσα 🤍",
  "Add a sparkly crown 👑": "Πρόσθεσε μια λαμπερή κορώνα 👑",
  "Add a sparkly jewelled crown 👑": "Πρόσθεσε μια λαμπερή κορώνα με πετράδια 👑",
  "Add a splashy puddle 💧": "Πρόσθεσε μια λακκούβα με νερά 💧",
  "Add a splashy tail": "Πρόσθεσε μια πλατσουριστή ουρά",
  "Add a star in the top corner ⭐": "Πρόσθεσε ένα αστέρι στην πάνω γωνία ⭐",
  "Add a star with seven points ⭐": "Πρόσθεσε ένα αστέρι με εφτά κορυφές ⭐",
  "Add a star ⭐": "Πρόσθεσε ένα αστέρι ⭐",
  "Add a swishy tail": "Πρόσθεσε μια κουνιστή ουρά",
  "Add a thinner cross inside ➕": "Πρόσθεσε έναν πιο λεπτό σταυρό μέσα ➕",
  "Add a thinner stripe inside it": "Πρόσθεσε μια πιο λεπτή ρίγα μέσα της",
  "Add a third row of tiny spikes!": "Πρόσθεσε μια τρίτη σειρά μικροσκοπικά αγκάθια!",
  "Add a triangle roof 🔺": "Πρόσθεσε μια τριγωνική σκεπή 🔺",
  "Add a wagging tail!": "Πρόσθεσε μια ουρά που κουνιέται!",
  "Add a water spout! 💦": "Πρόσθεσε ένα σιντριβάνι νερού! 💦",
  "Add a white snout in the middle": "Πρόσθεσε μια άσπρη μουσούδα στη μέση",
  "Add a wide orange beak 🟧": "Πρόσθεσε ένα φαρδύ πορτοκαλί ράμφος 🟧",
  "Add a wide stripe across the bottom": "Πρόσθεσε μια φαρδιά ρίγα στο κάτω μέρος",
  "Add a zig-zag lightning bolt! ⚡": "Πρόσθεσε μια αστραπή ζιγκ-ζαγκ! ⚡",
  "Add a zig-zag line down ⚡": "Πρόσθεσε μια κάθετη γραμμή ζιγκ-ζαγκ ⚡",
  "Add an apple on its back! 🍎": "Πρόσθεσε ένα μήλο στην πλάτη του! 🍎",
  "Add an eagle on top 🦅": "Πρόσθεσε έναν αετό από πάνω 🦅",
  "Add an eye and a happy smile 😊": "Πρόσθεσε ένα μάτι και ένα χαρούμενο χαμόγελο 😊",
  "Add an eye and spots 😄": "Πρόσθεσε ένα μάτι και βούλες 😄",
  "Add an eye, a nostril and a smile 👀": "Πρόσθεσε ένα μάτι, ένα ρουθούνι και ένα χαμόγελο 👀",
  "Add another row of rain": "Πρόσθεσε άλλη μια σειρά βροχής",
  "Add arms and legs": "Πρόσθεσε χέρια και πόδια",
  "Add bark lines on the trunk": "Πρόσθεσε γραμμές φλοιού στον κορμό",
  "Add big round wheels! ⚫": "Πρόσθεσε μεγάλες στρογγυλές ρόδες! ⚫",
  "Add big sharp teeth! 🦷": "Πρόσθεσε μεγάλα κοφτερά δόντια! 🦷",
  "Add big spots on the wings": "Πρόσθεσε μεγάλες βούλες στα φτερά",
  "Add big swirls in the sky 🌀": "Πρόσθεσε μεγάλους στροβίλους στον ουρανό 🌀",
  "Add bumpy plates along its back!": "Πρόσθεσε ανώμαλες πλάκες κατά μήκος της πλάτης του!",
  "Add colorful lips 👄": "Πρόσθεσε πολύχρωμα χείλη 👄",
  "Add cool sunglasses 😎": "Πρόσθεσε ωραία γυαλιά ηλίου 😎",
  "Add cool swooshy hair! 💇": "Πρόσθεσε ωραία ανεμιστά μαλλιά! 💇",
  "Add cosy stripes on its body 🐈": "Πρόσθεσε ζεστές ρίγες στο σώμα του 🐈",
  "Add curly smoke from the chimney 💨": "Πρόσθεσε σγουρό καπνό από την καμινάδα 💨",
  "Add curvy scales 🐟": "Πρόσθεσε καμπυλωτά λέπια 🐟",
  "Add diagonal rays in the corners": "Πρόσθεσε διαγώνιες αχτίδες στις γωνίες",
  "Add eight petals all around! 🌸": "Πρόσθεσε οκτώ πέταλα ολόγυρα! 🌸",
  "Add even more rain! 🌧️": "Πρόσθεσε ακόμα πιο πολλή βροχή! 🌧️",
  "Add eyes and a big smile 🎶": "Πρόσθεσε μάτια και ένα μεγάλο χαμόγελο 🎶",
  "Add eyes and eyebrows 👀": "Πρόσθεσε μάτια και φρύδια 👀",
  "Add fins on top and bottom": "Πρόσθεσε πτερύγια πάνω και κάτω",
  "Add five little stars ⭐": "Πρόσθεσε πέντε μικρά αστέρια ⭐",
  "Add foamy claws on top ☁️": "Πρόσθεσε αφρισμένα νύχια στην κορυφή ☁️",
  "Add four legs that join the body 🦵": "Πρόσθεσε τέσσερα πόδια που ενώνονται με το σώμα 🦵",
  "Add four little feet 🦶": "Πρόσθεσε τέσσερα μικρά πόδια 🦶",
  "Add four little stars ✨": "Πρόσθεσε τέσσερα μικρά αστέρια ✨",
  "Add front legs and paws 🐾": "Πρόσθεσε μπροστινά πόδια και πατούσες 🐾",
  "Add little Mount Fuji behind 🗻": "Πρόσθεσε το μικρό βουνό Φούτζι πίσω 🗻",
  "Add little bars in the corners": "Πρόσθεσε μικρές μπάρες στις γωνίες",
  "Add little seeds in the middle": "Πρόσθεσε μικρούς σπόρους στο κέντρο",
  "Add little stars in the sky! ⭐": "Πρόσθεσε μικρά αστέρια στον ουρανό! ⭐",
  "Add more rays in the corners! 🌟": "Πρόσθεσε κι άλλες αχτίδες στις γωνίες! 🌟",
  "Add nose, mouth and whiskers": "Πρόσθεσε μύτη, στόμα και μουστάκια",
  "Add one big eye and a nostril 👀": "Πρόσθεσε ένα μεγάλο μάτι και ένα ρουθούνι 👀",
  "Add petals all around! 🌸": "Πρόσθεσε πέταλα ολόγυρα! 🌸",
  "Add pretty spots! 🌈": "Πρόσθεσε όμορφες βούλες! 🌈",
  "Add raindrops falling from the clouds 💧": "Πρόσθεσε σταγόνες βροχής να πέφτουν από τα σύννεφα 💧",
  "Add rising bubbles! 🫧": "Πρόσθεσε φυσαλίδες που ανεβαίνουν! 🫧",
  "Add seeds and grass": "Πρόσθεσε σπόρους και γρασίδι",
  "Add shiny hubcaps in the wheels": "Πρόσθεσε γυαλιστερά τάσια στις ρόδες",
  "Add some big raindrops": "Πρόσθεσε μερικές μεγάλες σταγόνες βροχής",
  "Add some yummy apples! 🍎": "Πρόσθεσε μερικά νόστιμα μήλα! 🍎",
  "Add sparkles all around! ✨": "Πρόσθεσε λάμψεις ολόγυρα! ✨",
  "Add sparkles around it ✨": "Πρόσθεσε λάμψεις γύρω του ✨",
  "Add spikes on its back! ⚡": "Πρόσθεσε αγκάθια στην πλάτη του! ⚡",
  "Add straight sunny rays": "Πρόσθεσε ίσιες ηλιαχτίδες",
  "Add swirly patterns on the wings 🌈": "Πρόσθεσε στροβιλιστά σχέδια στα φτερά 🌈",
  "Add the back legs 🦵": "Πρόσθεσε τα πίσω πόδια 🦵",
  "Add the big round shell 🐚": "Πρόσθεσε το μεγάλο στρογγυλό κοχύλι 🐚",
  "Add the big top wings": "Πρόσθεσε τα μεγάλα πάνω φτερά",
  "Add the body": "Πρόσθεσε το σώμα",
  "Add the body and collar": "Πρόσθεσε το σώμα και τον γιακά",
  "Add the body and outfit": "Πρόσθεσε το σώμα και το ρούχο",
  "Add the body, arms and legs": "Πρόσθεσε το σώμα, τα χέρια και τα πόδια",
  "Add the bottom wings": "Πρόσθεσε τα κάτω φτερά",
  "Add the collar at the neck 🧵": "Πρόσθεσε τον γιακά στον λαιμό 🧵",
  "Add the cuffs and the shoulder seams ✂️": "Πρόσθεσε τα μανικέτια και τις ραφές των ώμων ✂️",
  "Add the eye mask and eyes 👀": "Πρόσθεσε τη μάσκα και τα μάτια 👀",
  "Add the eye mask 🦸": "Πρόσθεσε τη μάσκα ματιών 🦸",
  "Add the eye, nose and a smile 👁️": "Πρόσθεσε το μάτι, τη μύτη και ένα χαμόγελο 👁️",
  "Add the eyes and eyebrows 👀": "Πρόσθεσε τα μάτια και τα φρύδια 👀",
  "Add the eyes 👀": "Πρόσθεσε τα μάτια 👀",
  "Add the family pet dog! 🐕": "Πρόσθεσε τον σκύλο της οικογένειας! 🐕",
  "Add the first row of raindrops": "Πρόσθεσε την πρώτη σειρά σταγόνες βροχής",
  "Add the first row of spikes ⚡": "Πρόσθεσε την πρώτη σειρά αγκάθια ⚡",
  "Add the front legs and paws 🐾": "Πρόσθεσε τα μπροστινά πόδια και τις πατούσες 🐾",
  "Add the front legs — one prancing! 🦵": "Πρόσθεσε τα μπροστινά πόδια — το ένα να χοροπηδάει! 🦵",
  "Add the gill line and an eye": "Πρόσθεσε τη γραμμή του βράγχιου και ένα μάτι",
  "Add the hooves and a swishy tail!": "Πρόσθεσε τις οπλές και μια κουνιστή ουρά!",
  "Add the microphone 🎤": "Πρόσθεσε το μικρόφωνο 🎤",
  "Add the middle of the flower 🟡": "Πρόσθεσε το κέντρο του λουλουδιού 🟡",
  "Add the nose, mouth and whiskers": "Πρόσθεσε τη μύτη, το στόμα και τα μουστάκια",
  "Add the pointy cone underneath 🍦": "Πρόσθεσε το μυτερό χωνάκι από κάτω 🍦",
  "Add the road 🛣️": "Πρόσθεσε τον δρόμο 🛣️",
  "Add the roof and a chimney 🔺": "Πρόσθεσε τη σκεπή και μια καμινάδα 🔺",
  "Add the round middle 🟡": "Πρόσθεσε το στρογγυλό κέντρο 🟡",
  "Add the sitting body": "Πρόσθεσε το σώμα καθιστό",
  "Add the stars ⭐": "Πρόσθεσε τα αστέρια ⭐",
  "Add the underarm lines and the side seams 🧵": "Πρόσθεσε τις γραμμές της μασχάλης και τις πλαϊνές ραφές 🧵",
  "Add the white parts of the eyes ⚪": "Πρόσθεσε τα άσπρα μέρη των ματιών ⚪",
  "Add the windows 🪟": "Πρόσθεσε τα παράθυρα 🪟",
  "Add thin red lines between the stripes": "Πρόσθεσε λεπτές κόκκινες γραμμές ανάμεσα στις ρίγες",
  "Add twinkly stars! ⭐": "Πρόσθεσε λαμπερά αστέρια! ⭐",
  "Add two big eye bumps on top 👀": "Πρόσθεσε δύο μεγάλα εξογκώματα ματιών στην κορυφή 👀",
  "Add two big eyes 👀": "Πρόσθεσε δύο μεγάλα μάτια 👀",
  "Add two big floppy ears 👂": "Πρόσθεσε δύο μεγάλα κρεμαστά αυτιά 👂",
  "Add two big round ears 👂": "Πρόσθεσε δύο μεγάλα στρογγυλά αυτιά 👂",
  "Add two big round eyes 👀": "Πρόσθεσε δύο μεγάλα στρογγυλά μάτια 👀",
  "Add two big wheels ⚫": "Πρόσθεσε δύο μεγάλες ρόδες ⚫",
  "Add two ears on the sides 👂": "Πρόσθεσε δύο αυτιά στα πλάγια 👂",
  "Add two eyes — make them different! 👁️": "Πρόσθεσε δύο μάτια — κάνε τα διαφορετικά! 👁️",
  "Add two eyes — one round, one from the side! 👁️": "Πρόσθεσε δύο μάτια — ένα στρογγυλό, ένα από το πλάι! 👁️",
  "Add two eyes 👀": "Πρόσθεσε δύο μάτια 👀",
  "Add two floppy ears 👂": "Πρόσθεσε δύο κρεμαστά αυτιά 👂",
  "Add two lines across": "Πρόσθεσε δύο οριζόντιες γραμμές",
  "Add two lines down": "Πρόσθεσε δύο κάθετες γραμμές",
  "Add two little ears 👂": "Πρόσθεσε δύο μικρά αυτιά 👂",
  "Add two little feelers 👀": "Πρόσθεσε δύο μικρές κεραίες 👀",
  "Add two little feet 🧡": "Πρόσθεσε δύο μικρά πόδια 🧡",
  "Add two little horns 🔶": "Πρόσθεσε δύο μικρά κέρατα 🔶",
  "Add two little tusks": "Πρόσθεσε δύο μικρούς χαυλιόδοντες",
  "Add two pointy ears on top 🔺": "Πρόσθεσε δύο μυτερά αυτιά στην κορυφή 🔺",
  "Add two pointy ears 🔺": "Πρόσθεσε δύο μυτερά αυτιά 🔺",
  "Add two puffy cheeks 😊": "Πρόσθεσε δύο φουσκωτά μάγουλα 😊",
  "Add two rosy cheeks 😊": "Πρόσθεσε δύο ροδαλά μάγουλα 😊",
  "Add two round ears on top 👂": "Πρόσθεσε δύο στρογγυλά αυτιά στην κορυφή 👂",
  "Add two round eyes 👀": "Πρόσθεσε δύο στρογγυλά μάτια 👀",
  "Add two rows of curvy scales 🐟": "Πρόσθεσε δύο σειρές καμπυλωτά λέπια 🐟",
  "Add two tall ears 👂": "Πρόσθεσε δύο ψηλά αυτιά 👂",
  "Add two tiny nostrils 👃": "Πρόσθεσε δύο μικροσκοπικά ρουθούνια 👃",
  "Add two windows 🪟": "Πρόσθεσε δύο παράθυρα 🪟",
  "Add wavy seaweed 🌿": "Πρόσθεσε κυματιστά φύκια 🌿",
  "Add windows with little panes 🪟": "Πρόσθεσε παράθυρα με μικρά τζάμια 🪟",
  "Add yummy apples! 🍎": "Πρόσθεσε νόστιμα μήλα! 🍎",
  "Almost there 🔵": "Σχεδόν έφτασες 🔵",
  "And one on the right! ☁️": "Και ένα δεξιά! ☁️",
  "And that’s little you! 🙂": "Κι αυτό το μικρό είσαι εσύ! 🙂",
  "Another arc just inside 🟠": "Άλλο ένα τόξο ακριβώς από μέσα 🟠",
  "Another one 🟢": "Άλλο ένα 🟢",
  "Brew a storm cloud on the right! ☁️": "Φτιάξε ένα σύννεφο καταιγίδας στα δεξιά! ☁️",
  "Buttery yellow for the horn! 🌟": "Απαλό κίτρινο για το κέρατο! 🌟",
  "Colour the red trim first! 🖍️": "Χρωμάτισε πρώτα την κόκκινη μπορντούρα! 🖍️",
  "Draw 4 thin red diagonal stripes ╳": "Ζωγράφισε 4 λεπτές κόκκινες διαγώνιες ρίγες ╳",
  "Draw 8 blue triangles in the corners 🔺": "Ζωγράφισε 8 μπλε τρίγωνα στις γωνίες 🔺",
  "Draw Daddy 🧔": "Ζωγράφισε τον μπαμπά 🧔",
  "Draw Mommy 👩": "Ζωγράφισε τη μαμά 👩",
  "Draw a big circle in the middle ⭕": "Ζωγράφισε έναν μεγάλο κύκλο στη μέση ⭕",
  "Draw a big diamond 💎": "Ζωγράφισε έναν μεγάλο ρόμβο 💎",
  "Draw a big fluffy cloud ☁️": "Ζωγράφισε ένα μεγάλο αφράτο σύννεφο ☁️",
  "Draw a big fluffy mane! 🦁": "Ζωγράφισε μια μεγάλη αφράτη χαίτη! 🦁",
  "Draw a big head shape 🟣": "Ζωγράφισε ένα μεγάλο σχήμα κεφαλιού 🟣",
  "Draw a big red cross ✚": "Ζωγράφισε έναν μεγάλο κόκκινο σταυρό ✚",
  "Draw a big round body 🦕": "Ζωγράφισε ένα μεγάλο στρογγυλό σώμα 🦕",
  "Draw a big round body! 🐳": "Ζωγράφισε ένα μεγάλο στρογγυλό σώμα! 🐳",
  "Draw a big round head! 🐹": "Ζωγράφισε ένα μεγάλο στρογγυλό κεφάλι! 🐹",
  "Draw a big round head! 🐻": "Ζωγράφισε ένα μεγάλο στρογγυλό κεφάλι! 🐻",
  "Draw a big round penguin body! 🐧": "Ζωγράφισε ένα μεγάλο στρογγυλό σώμα πιγκουίνου! 🐧",
  "Draw a big round sun ☀️": "Ζωγράφισε έναν μεγάλο στρογγυλό ήλιο ☀️",
  "Draw a big star in the middle ⭐": "Ζωγράφισε ένα μεγάλο αστέρι στη μέση ⭐",
  "Draw a big thick red cross ✚": "Ζωγράφισε έναν μεγάλο χοντρό κόκκινο σταυρό ✚",
  "Draw a big twinkly star ⭐": "Ζωγράφισε ένα μεγάλο λαμπερό αστέρι ⭐",
  "Draw a big white X corner to corner ╳": "Ζωγράφισε ένα μεγάλο άσπρο Χ από γωνία σε γωνία ╳",
  "Draw a big yellow triangle 🔺": "Ζωγράφισε ένα μεγάλο κίτρινο τρίγωνο 🔺",
  "Draw a circle in the middle ⭕": "Ζωγράφισε έναν κύκλο στη μέση ⭕",
  "Draw a circle inside ⭕": "Ζωγράφισε έναν κύκλο μέσα ⭕",
  "Draw a crescent moon 🌙": "Ζωγράφισε ένα μισοφέγγαρο 🌙",
  "Draw a curvy line down the middle — that splits the face!": "Ζωγράφισε μια καμπυλωτή γραμμή στη μέση — που χωρίζει το πρόσωπο!",
  "Draw a five-point star in the middle ⭐": "Ζωγράφισε ένα πεντάκτινο αστέρι στη μέση ⭐",
  "Draw a fluffy cloud ☁️": "Ζωγράφισε ένα αφράτο σύννεφο ☁️",
  "Draw a green five-point star ⭐": "Ζωγράφισε ένα πράσινο πεντάκτινο αστέρι ⭐",
  "Draw a line on the beak 〰️": "Ζωγράφισε μια γραμμή στο ράμφος 〰️",
  "Draw a little cactus in the middle 🌵": "Ζωγράφισε έναν μικρό κάκτο στη μέση 🌵",
  "Draw a little eagle in the middle 🦅": "Ζωγράφισε έναν μικρό αετό στη μέση 🦅",
  "Draw a little house behind 🏠": "Ζωγράφισε ένα μικρό σπίτι πίσω 🏠",
  "Draw a little red emblem in the middle 🌷": "Ζωγράφισε ένα μικρό κόκκινο σήμα στη μέση 🌷",
  "Draw a little white box in the middle": "Ζωγράφισε ένα μικρό άσπρο πλαίσιο στη μέση",
  "Draw a long horse head and neck from the side 🟫": "Ζωγράφισε ένα μακρύ κεφάλι και λαιμό αλόγου από το πλάι 🟫",
  "Draw a long sword underneath 🗡️": "Ζωγράφισε ένα μακρύ σπαθί από κάτω 🗡️",
  "Draw a maple leaf in the middle 🍁": "Ζωγράφισε ένα φύλλο σφενδάμου στη μέση 🍁",
  "Draw a palm tree on a hill 🌴": "Ζωγράφισε έναν φοίνικα σε έναν λόφο 🌴",
  "Draw a round badge in the middle": "Ζωγράφισε ένα στρογγυλό σήμα στη μέση",
  "Draw a round head 🟠": "Ζωγράφισε ένα στρογγυλό κεφάλι 🟠",
  "Draw a round head! 🐘": "Ζωγράφισε ένα στρογγυλό κεφάλι! 🐘",
  "Draw a round head! 🐭": "Ζωγράφισε ένα στρογγυλό κεφάλι! 🐭",
  "Draw a round head! 🐮": "Ζωγράφισε ένα στρογγυλό κεφάλι! 🐮",
  "Draw a round head! 🐰": "Ζωγράφισε ένα στρογγυλό κεφάλι! 🐰",
  "Draw a round head! 🐷": "Ζωγράφισε ένα στρογγυλό κεφάλι! 🐷",
  "Draw a round head! 🦆": "Ζωγράφισε ένα στρογγυλό κεφάλι! 🦆",
  "Draw a round head! 🦊": "Ζωγράφισε ένα στρογγυλό κεφάλι! 🦊",
  "Draw a shield and a crown 👑": "Ζωγράφισε μια ασπίδα και μια κορώνα 👑",
  "Draw a shield in the middle 🛡️": "Ζωγράφισε μια ασπίδα στη μέση 🛡️",
  "Draw a shield with a bird on top 🛡️": "Ζωγράφισε μια ασπίδα με ένα πουλί από πάνω 🛡️",
  "Draw a sideways green Y across the flag": "Ζωγράφισε ένα πλάγιο πράσινο Υ κατά μήκος της σημαίας",
  "Draw a smiling sun in the box ☀️": "Ζωγράφισε έναν χαμογελαστό ήλιο στο πλαίσιο ☀️",
  "Draw a smiling sun in the middle ☀️": "Ζωγράφισε έναν χαμογελαστό ήλιο στη μέση ☀️",
  "Draw a star inside a ring ⭐": "Ζωγράφισε ένα αστέρι μέσα σε έναν κύκλο ⭐",
  "Draw a triangle at the left edge 🔺": "Ζωγράφισε ένα τρίγωνο στην αριστερή άκρη 🔺",
  "Draw a triangle from the side 🔺": "Ζωγράφισε ένα τρίγωνο από το πλάι 🔺",
  "Draw a triangle on the left 🔺": "Ζωγράφισε ένα τρίγωνο στα αριστερά 🔺",
  "Draw a twinkly star ⭐": "Ζωγράφισε ένα λαμπερό αστέρι ⭐",
  "Draw a wheel in the middle ☸️": "Ζωγράφισε έναν τροχό στη μέση ☸️",
  "Draw a wide round head! 🐸": "Ζωγράφισε ένα φαρδύ στρογγυλό κεφάλι! 🐸",
  "Draw a wide stripe corner to corner": "Ζωγράφισε μια φαρδιά ρίγα από γωνία σε γωνία",
  "Draw a wonky face shape 🟦": "Ζωγράφισε ένα στραβό σχήμα προσώπου 🟦",
  "Draw her big flowy dress 👗": "Ζωγράφισε το μεγάλο ανάλαφρο φόρεμά της 👗",
  "Draw her castle in the distance 🏰": "Ζωγράφισε το κάστρο της στο βάθος 🏰",
  "Draw her hair fringe": "Ζωγράφισε την αφέλεια στα μαλλιά της",
  "Draw one big star ⭐": "Ζωγράφισε ένα μεγάλο αστέρι ⭐",
  "Draw the back and the round tummy 🐴": "Ζωγράφισε την πλάτη και τη στρογγυλή κοιλίτσα 🐴",
  "Draw the big curling wave 🌊": "Ζωγράφισε το μεγάλο κυρτό κύμα 🌊",
  "Draw the big happy eyes 👀": "Ζωγράφισε τα μεγάλα χαρούμενα μάτια 👀",
  "Draw the biggest arc 🔴": "Ζωγράφισε το πιο μεγάλο τόξο 🔴",
  "Draw the body and antennae 🦋": "Ζωγράφισε το σώμα και τις κεραίες 🦋",
  "Draw the body, segments and antennae": "Ζωγράφισε το σώμα, τις φέτες και τις κεραίες",
  "Draw the car body 🚗": "Ζωγράφισε το αμάξωμα του αυτοκινήτου 🚗",
  "Draw the door with a doorknob 🚪": "Ζωγράφισε την πόρτα με ένα πόμολο 🚪",
  "Draw the door 🚪": "Ζωγράφισε την πόρτα 🚪",
  "Draw the face and cool hair": "Ζωγράφισε το πρόσωπο και τα ωραία μαλλιά",
  "Draw the fish body": "Ζωγράφισε το σώμα του ψαριού",
  "Draw the fish body 🐟": "Ζωγράφισε το σώμα του ψαριού 🐟",
  "Draw the flag's box 🏁": "Ζωγράφισε το πλαίσιο της σημαίας 🏁",
  "Draw the flowing mane": "Ζωγράφισε τη χαίτη που κυματίζει",
  "Draw the flowing mane down the neck 💇": "Ζωγράφισε τη χαίτη να πέφτει στον λαιμό 💇",
  "Draw the grassy ground 🌱": "Ζωγράφισε το χορταριασμένο έδαφος 🌱",
  "Draw the happy eyes 👀": "Ζωγράφισε τα χαρούμενα μάτια 👀",
  "Draw the head with a soft snout 🐴": "Ζωγράφισε το κεφάλι με μια απαλή μουσούδα 🐴",
  "Draw the hem, then start the big number 🔢": "Ζωγράφισε το στρίφωμα και μετά ξεκίνα τον μεγάλο αριθμό 🔢",
  "Draw the hero's head 🦸": "Ζωγράφισε το κεφάλι του ήρωα 🦸",
  "Draw the left side of the heart": "Ζωγράφισε την αριστερή πλευρά της καρδιάς",
  "Draw the magic horn 🌟": "Ζωγράφισε το μαγικό κέρατο 🌟",
  "Draw the nose and a smiley mouth 👃": "Ζωγράφισε τη μύτη και ένα χαμογελαστό στόμα 👃",
  "Draw the nose and mouth 👃": "Ζωγράφισε τη μύτη και το στόμα 👃",
  "Draw the rolling hills at the bottom 🏞️": "Ζωγράφισε τους κυματιστούς λόφους στο κάτω μέρος 🏞️",
  "Draw the round body and pointy nose 🟤": "Ζωγράφισε το στρογγυλό σώμα και τη μυτερή μύτη 🟤",
  "Draw the round ice cream scoop 🍦": "Ζωγράφισε τη στρογγυλή μπάλα παγωτού 🍦",
  "Draw the shoulders and the sleeves 💪": "Ζωγράφισε τους ώμους και τα μανίκια 💪",
  "Draw the snail's long foot 🐌": "Ζωγράφισε το μακρύ πόδι του σαλιγκαριού 🐌",
  "Draw the stem and a leaf 🌿": "Ζωγράφισε τον μίσχο και ένα φύλλο 🌿",
  "Draw the stem and two leaves 🌿": "Ζωγράφισε τον μίσχο και δύο φύλλα 🌿",
  "Draw the swirl on the shell 🌀": "Ζωγράφισε τη σπείρα στο κοχύλι 🌀",
  "Draw the trunk with roots 🟫": "Ζωγράφισε τον κορμό με ρίζες 🟫",
  "Draw the trunk 🟫": "Ζωγράφισε τον κορμό 🟫",
  "Draw the two sides and the bottom of the shirt 👕": "Ζωγράφισε τις δύο πλευρές και το κάτω μέρος της μπλούζας 👕",
  "Draw the waffle lines on the cone 🧇": "Ζωγράφισε τις γραμμές βάφλας στο χωνάκι 🧇",
  "Draw the walls (a big square) 🟫": "Ζωγράφισε τους τοίχους (ένα μεγάλο τετράγωνο) 🟫",
  "Draw two stars ⭐": "Ζωγράφισε δύο αστέρια ⭐",
  "Draw two white stars in the corner ⭐": "Ζωγράφισε δύο άσπρα αστέρια στη γωνία ⭐",
  "Draw your big brother or sister 🧒": "Ζωγράφισε τον μεγάλο σου αδερφό ή αδερφή 🧒",
  "Fill it with a checkerboard ▩": "Γέμισέ την με ένα καρό μοτίβο ▩",
  "Finish the arcs with violet! 🟣": "Τελείωσε τα τόξα με βιολετί! 🟣",
  "Finish with a ball of yarn to play with! 🧶": "Τελείωσε με ένα κουβάρι για να παίζει! 🧶",
  "Finish with a bright sun! ☀️": "Τελείωσε με έναν λαμπερό ήλιο! ☀️",
  "Finish with a curly tail!": "Τελείωσε με μια σγουρή ουρά!",
  "Finish with a flower and grass 🌸": "Τελείωσε με ένα λουλούδι και γρασίδι 🌸",
  "Finish with a fluffy cloud ☁️": "Τελείωσε με ένα αφράτο σύννεφο ☁️",
  "Finish with a friendly eye! 😄": "Τελείωσε με ένα φιλικό μάτι! 😄",
  "Finish with a happy smile! 😄": "Τελείωσε με ένα χαρούμενο χαμόγελο! 😄",
  "Finish with a happy smile! 🦔": "Τελείωσε με ένα χαρούμενο χαμόγελο! 🦔",
  "Finish with a lightning emblem in a shield! ⚡": "Τελείωσε με ένα σήμα-αστραπή σε μια ασπίδα! ⚡",
  "Finish with a lightning emblem on the chest! ⚡": "Τελείωσε με ένα σήμα-αστραπή στο στήθος! ⚡",
  "Finish with a row of flowers below! 🌷": "Τελείωσε με μια σειρά λουλούδια από κάτω! 🌷",
  "Finish with a shining sun! ☀️": "Τελείωσε με έναν λαμπερό ήλιο! ☀️",
  "Finish with a sparkly star! ⭐": "Τελείωσε με ένα λαμπερό αστέρι! ⭐",
  "Finish with a splashy puddle 💧": "Τελείωσε με μια λακκούβα με νερά 💧",
  "Finish with a sun and a path! ☀️": "Τελείωσε με έναν ήλιο και ένα μονοπάτι! ☀️",
  "Finish with a sun and birds! ☀️🐦": "Τελείωσε με έναν ήλιο και πουλιά! ☀️🐦",
  "Finish with a sunny sky! ☀️": "Τελείωσε με έναν ηλιόλουστο ουρανό! ☀️",
  "Finish with a wagging tail!": "Τελείωσε με μια ουρά που κουνιέται!",
  "Finish with an apple on its back! 🍎": "Τελείωσε με ένα μήλο στην πλάτη του! 🍎",
  "Finish with an eye and a smile! 🐠": "Τελείωσε με ένα μάτι και ένα χαμόγελο! 🐠",
  "Finish with an eye and spots 😄": "Τελείωσε με ένα μάτι και βούλες 😄",
  "Finish with birds flying by! 🐦": "Τελείωσε με πουλιά που πετάνε! 🐦",
  "Finish with bubbles! 🫧": "Τελείωσε με φυσαλίδες! 🫧",
  "Finish with cubist lines! 🎨": "Τελείωσε με κυβιστικές γραμμές! 🎨",
  "Finish with grass at the bottom! 🌱": "Τελείωσε με γρασίδι στο κάτω μέρος! 🌱",
  "Finish with little boats riding the sea ⛵": "Τελείωσε με μικρές βάρκες να αρμενίζουν στη θάλασσα ⛵",
  "Finish with little hearts floating up!": "Τελείωσε με καρδούλες που ανεβαίνουν στον αέρα!",
  "Finish with little hooves and a swishy tail!": "Τελείωσε με μικρές οπλές και μια κουνιστή ουρά!",
  "Finish with musical notes and a star! 🎵⭐": "Τελείωσε με μουσικές νότες και ένα αστέρι! 🎵⭐",
  "Finish with musical notes! 🎵": "Τελείωσε με μουσικές νότες! 🎵",
  "Finish with swirly wing patterns! 🌈": "Τελείωσε με στροβιλιστά σχέδια στα φτερά! 🌈",
  "Finish with the ground and a bone! 🦴": "Τελείωσε με το έδαφος και ένα κόκαλο! 🦴",
  "Finish with the ground and a fern 🌿": "Τελείωσε με το έδαφος και μια φτέρη 🌿",
  "Finish with the road! 🛣️": "Τελείωσε με τον δρόμο! 🛣️",
  "Finish with the sun! ☀️": "Τελείωσε με τον ήλιο! ☀️",
  "Finish with the tall cypress tree 🌲": "Τελείωσε με το ψηλό κυπαρίσσι 🌲",
  "Finish with two little hearts!": "Τελείωσε με δύο μικρές καρδούλες!",
  "Finish with whiskers and a smile! 😺": "Τελείωσε με μουστάκια και ένα χαμόγελο! 😺",
  "Finish with wild hair and an ear! 🎨": "Τελείωσε με ατίθασα μαλλιά και ένα αυτί! 🎨",
  "Flow the wavy mane down the neck 🌊": "Άσε την κυματιστή χαίτη να πέφτει στον λαιμό 🌊",
  "Give her a happy smile 😊": "Δώσε της ένα χαρούμενο χαμόγελο 😊",
  "Give it a cute nose 👃": "Δώσε του μια χαριτωμένη μύτη 👃",
  "Give it a happy face! 😊": "Δώσε του ένα χαρούμενο πρόσωπο! 😊",
  "Give it an eye and a nose 👁️": "Δώσε του ένα μάτι και μια μύτη 👁️",
  "Give it four chunky legs and feet": "Δώσε του τέσσερα χοντρά πόδια και πατούσες",
  "Give the number its 3-D edge 🔢": "Δώσε στον αριθμό το τρισδιάστατο περίγραμμά του 🔢",
  "Give the pony a saddle 🏇": "Δώσε στο πόνι μια σέλα 🏇",
  "Give the sun a happy face 😊": "Δώσε στον ήλιο ένα χαρούμενο πρόσωπο 😊",
  "Give the sun a happy face 🙂": "Δώσε στον ήλιο ένα χαρούμενο πρόσωπο 🙂",
  "Green next 🟢": "Πράσινο μετά 🟢",
  "Hang a little swing from a branch 🪢": "Κρέμασε μια μικρή κούνια από ένα κλαδί 🪢",
  "Indigo after that": "Λουλακί στη συνέχεια",
  "Keep going 🟡": "Συνέχισε 🟡",
  "Last of all, write the dog's name: D-O-G! ✏️": "Στο τέλος, γράψε το όνομα του σκύλου: D-O-G! ✏️",
  "Lilac swirls next! 💜": "Λιλά στροβίλους μετά! 💜",
  "Make a little flag box in the corner": "Φτιάξε ένα μικρό πλαίσιο σημαίας στη γωνία",
  "Make a sunny meadow with grass ☀️": "Φτιάξε ένα ηλιόλουστο λιβάδι με γρασίδι ☀️",
  "Now bring it to life with color! 🎨": "Τώρα δώσε του ζωή με χρώμα! 🎨",
  "Now color her all in! 🖍️": "Τώρα χρωμάτισέ την όλη! 🖍️",
  "Now color him all in! 🖍️": "Τώρα χρωμάτισέ τον όλο! 🖍️",
  "Now color it all in! 🖍️": "Τώρα χρωμάτισέ το όλο! 🖍️",
  "Now color it in! 🖍️": "Τώρα χρωμάτισέ το! 🖍️",
  "Now color the bear in! 🖍️": "Τώρα χρωμάτισε την αρκούδα! 🖍️",
  "Now color the bunny in! 🖍️": "Τώρα χρωμάτισε το κουνελάκι! 🖍️",
  "Now color the cloud in! 🖍️": "Τώρα χρωμάτισε το σύννεφο! 🖍️",
  "Now color the cow in! 🖍️": "Τώρα χρωμάτισε την αγελάδα! 🖍️",
  "Now color the duck in! 🖍️": "Τώρα χρωμάτισε την πάπια! 🖍️",
  "Now color the elephant in! 🖍️": "Τώρα χρωμάτισε τον ελέφαντα! 🖍️",
  "Now color the fish in! 🖍️": "Τώρα χρωμάτισε το ψάρι! 🖍️",
  "Now color the fox in! 🖍️": "Τώρα χρωμάτισε την αλεπού! 🖍️",
  "Now color the frog in! 🖍️": "Τώρα χρωμάτισε τον βάτραχο! 🖍️",
  "Now color the hamster in! 🖍️": "Τώρα χρωμάτισε το χάμστερ! 🖍️",
  "Now color the horse in! 🖍️": "Τώρα χρωμάτισε το άλογο! 🖍️",
  "Now color the lion in! 🖍️": "Τώρα χρωμάτισε το λιοντάρι! 🖍️",
  "Now color the mouse in! 🖍️": "Τώρα χρωμάτισε το ποντίκι! 🖍️",
  "Now color the penguin in! 🖍️": "Τώρα χρωμάτισε τον πιγκουίνο! 🖍️",
  "Now color the pig in! 🖍️": "Τώρα χρωμάτισε το γουρουνάκι! 🖍️",
  "Now color the whale in! 🖍️": "Τώρα χρωμάτισε τη φάλαινα! 🖍️",
  "Now color the whole rainbow in! 🌈": "Τώρα χρωμάτισε όλο το ουράνιο τόξο! 🌈",
  "Now color the whole sky in! 🌈": "Τώρα χρωμάτισε όλο τον ουρανό! 🌈",
  "Now colour the flag in! 🖍️": "Τώρα χρωμάτισε τη σημαία! 🖍️",
  "Now colour the shirt blue! 🖍️": "Τώρα χρωμάτισε τη μπλούζα μπλε! 🖍️",
  "Now colour your circle in! 🖍️": "Τώρα χρωμάτισε τον κύκλο σου! 🖍️",
  "Now colour your crescent in! 🖍️": "Τώρα χρωμάτισε το μισοφέγγαρό σου! 🖍️",
  "Now colour your diamond in! 🖍️": "Τώρα χρωμάτισε τον ρόμβο σου! 🖍️",
  "Now colour your family in! 🖍️": "Τώρα χρωμάτισε την οικογένειά σου! 🖍️",
  "Now colour your family scene in! 🖍️": "Τώρα χρωμάτισε τη σκηνή με την οικογένειά σου! 🖍️",
  "Now colour your heart in! 🖍️": "Τώρα χρωμάτισε την καρδιά σου! 🖍️",
  "Now colour your hexagon in! 🖍️": "Τώρα χρωμάτισε το εξάγωνό σου! 🖍️",
  "Now colour your ice cream in! 🖍️": "Τώρα χρωμάτισε το παγωτό σου! 🖍️",
  "Now colour your octagon in! 🖍️": "Τώρα χρωμάτισε το οκτάγωνό σου! 🖍️",
  "Now colour your oval in! 🖍️": "Τώρα χρωμάτισε το οβάλ σου! 🖍️",
  "Now colour your parallelogram in! 🖍️": "Τώρα χρωμάτισε το παραλληλόγραμμό σου! 🖍️",
  "Now colour your pentagon in! 🖍️": "Τώρα χρωμάτισε το πεντάγωνό σου! 🖍️",
  "Now colour your rectangle in! 🖍️": "Τώρα χρωμάτισε το ορθογώνιό σου! 🖍️",
  "Now colour your snail in! 🖍️": "Τώρα χρωμάτισε το σαλιγκάρι σου! 🖍️",
  "Now colour your square in! 🖍️": "Τώρα χρωμάτισε το τετράγωνό σου! 🖍️",
  "Now colour your star in! 🖍️": "Τώρα χρωμάτισε το αστέρι σου! 🖍️",
  "Now colour your trapezium in! 🖍️": "Τώρα χρωμάτισε το τραπέζιό σου! 🖍️",
  "Now colour your triangle in! 🖍️": "Τώρα χρωμάτισε το τρίγωνό σου! 🖍️",
  "Now colour your unicorn in! 🖍️": "Τώρα χρωμάτισε τον μονόκερό σου! 🖍️",
  "Now creamy peach swirls! 🍑": "Τώρα κρεμώδεις ροδακινί στροβίλους! 🍑",
  "Now draw two big eyes 👀": "Τώρα ζωγράφισε δύο μεγάλα μάτια 👀",
  "Now mirror it on the right! ❤️": "Τώρα κάνε το ίδιο στα δεξιά! ❤️",
  "Now orange 🟠": "Τώρα πορτοκαλί 🟠",
  "Now two sparkly eyes 👀": "Τώρα δύο λαμπερά μάτια 👀",
  "Pink for the mane! 🩷": "Ροζ για τη χαίτη! 🩷",
  "Plant a tree beside the house 🌳": "Φύτεψε ένα δέντρο δίπλα στο σπίτι 🌳",
  "Put the star on a stage with a spotlight! 🔦": "Βάλε το αστέρι σε μια σκηνή με προβολέα! 🔦",
  "Shoot an arrow through it! 🏹": "Πέρνα ένα βέλος μέσα της! 🏹",
  "Split it into four boxes": "Χώρισέ το σε τέσσερα κουτιά",
  "Spread a magical wing ✨": "Άπλωσε ένα μαγικό φτερό ✨",
  "Start with a big round head 🟤": "Ξεκίνα με ένα μεγάλο στρογγυλό κεφάλι 🟤",
  "Start with a big round head! 🟤": "Ξεκίνα με ένα μεγάλο στρογγυλό κεφάλι! 🟤",
  "Start with a big rounded body": "Ξεκίνα με ένα μεγάλο στρογγυλό σώμα",
  "Start with a red arc 🔴": "Ξεκίνα με ένα κόκκινο τόξο 🔴",
  "Start with the pony's body": "Ξεκίνα με το σώμα του πόνι",
  "Start with the round head": "Ξεκίνα με το στρογγυλό κεφάλι",
  "Sweep the fringe around the horn 💇": "Σχεδίασε την αφέλεια γύρω από το κέρατο 💇",
  "Swish a big wavy tail 🌊": "Ζωγράφισε μια μεγάλη κυματιστή ουρά 🌊",
  "The littlest arc 🟣": "Το πιο μικρό τόξο 🟣",
  "Then blue 🔵": "Μετά μπλε 🔵",
  "Then yellow 🟡": "Μετά κίτρινο 🟡",
  "This is a CIRCLE! Draw one big round circle ⭕": "Αυτό είναι ΚΥΚΛΟΣ! Ζωγράφισε έναν μεγάλο στρογγυλό κύκλο ⭕",
  "This is a CRESCENT! The curvy shape of the moon 🌙": "Αυτό είναι ΜΙΣΟΦΕΓΓΑΡΟ! Το καμπυλωτό σχήμα του φεγγαριού 🌙",
  "This is a DIAMOND! A square standing on its point 💎": "Αυτό είναι ΡΟΜΒΟΣ! Ένα τετράγωνο που στέκεται στη μύτη του 💎",
  "This is a HEART! Draw two bumps and a point ❤️": "Αυτό είναι ΚΑΡΔΙΑ! Ζωγράφισε δύο καμπύλες και μια μύτη ❤️",
  "This is a HEXAGON! Draw 6 straight sides ⬡": "Αυτό είναι ΕΞΑΓΩΝΟ! Ζωγράφισε 6 ίσιες πλευρές ⬡",
  "This is a PARALLELOGRAM! A rectangle that leans over ▱": "Αυτό είναι ΠΑΡΑΛΛΗΛΟΓΡΑΜΜΟ! Ένα ορθογώνιο που γέρνει στο πλάι ▱",
  "This is a PENTAGON! Draw 5 straight sides ⬠": "Αυτό είναι ΠΕΝΤΑΓΩΝΟ! Ζωγράφισε 5 ίσιες πλευρές ⬠",
  "This is a RECTANGLE! 2 long sides and 2 short sides ▭": "Αυτό είναι ΟΡΘΟΓΩΝΙΟ! 2 μακριές πλευρές και 2 κοντές πλευρές ▭",
  "This is a SQUARE! Draw 4 sides that are all the same 🟦": "Αυτό είναι ΤΕΤΡΑΓΩΝΟ! Ζωγράφισε 4 πλευρές ίδιες μεταξύ τους 🟦",
  "This is a STAR! Draw 5 pointy points ⭐": "Αυτό είναι ΑΣΤΕΡΙ! Ζωγράφισε 5 μυτερές κορυφές ⭐",
  "This is a TRAPEZIUM! Narrow on top, wide at the bottom ⏢": "Αυτό είναι ΤΡΑΠΕΖΙΟ! Στενό στην κορυφή, φαρδύ στη βάση ⏢",
  "This is a TRIANGLE! Draw 3 straight sides 🔺": "Αυτό είναι ΤΡΙΓΩΝΟ! Ζωγράφισε 3 ίσιες πλευρές 🔺",
  "This is an OCTAGON! Draw 8 straight sides 🛑": "Αυτό είναι ΟΚΤΑΓΩΝΟ! Ζωγράφισε 8 ίσιες πλευρές 🛑",
  "This is an OVAL! Like a circle, but stretched 🥚": "Αυτό είναι ΟΒΑΛ! Σαν κύκλος, αλλά τεντωμένος 🥚",
  "Trace the black border ⬛": "Σχεδίασε το μαύρο περίγραμμα ⬛",
  "Trace the black borders ⬛": "Σχεδίασε τα μαύρα περιγράμματα ⬛",
  "Write some white marks across ✍️": "Γράψε μερικά άσπρα σημάδια κατά μήκος ✍️",
  "Write the player's name — MBAPPÉ ⚽": "Γράψε το όνομα του παίκτη — MBAPPÉ ⚽",
  "Write the words \"Ordem e Progresso\" — \"Order and Progress\"! ✍️": "Γράψε τις λέξεις «Ordem e Progresso» — «Τάξη και Πρόοδος»! ✍️",
  "Write three little green marks ✍️": "Γράψε τρία μικρά πράσινα σημάδια ✍️",
};

/** The "write the name" finale hint, built from the spelt-out Greek letters. */
export const nameHintEl = (spelt: string): string =>
  `Τέλος, γράψε το όνομα: ${spelt}! ✏️`;

// Spoken aliases per drawing. Empty: aliasesFor() falls back to the localized
// Greek name (lower-cased), which is the right word to say in Greek, so every
// drawing already answers to its Greek name without an explicit entry here.
export const ALIASES_EL: Record<string, string[]> = {};
